import { SearchMd } from "@untitledui/icons";
import { type ReactNode, useEffect, useRef } from "react";
import { Input } from "@/components/base/input/input";
import { focusOnSuperKey } from "@/utils/keyboard-shortcuts";

type PageHeaderProps = {
  title: string;
  subtitle: string;
  count?: number;
  search?: string;
  onSearchChange?: (value: string) => void;
  actions?: ReactNode;
  icon?: React.ComponentType<{
    className?: string;
    style?: React.CSSProperties;
  }> | null;
};

export const PageHeader = ({
  title,
  subtitle,
  count,
  search,
  onSearchChange,
  actions,
  icon: Icon,
}: PageHeaderProps) => {
  const searchGroupRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!onSearchChange) return;

    const focusOnSuperKeyPlusK = (event: KeyboardEvent) => focusOnSuperKey(event, searchGroupRef, "k");

    window.addEventListener("keydown", focusOnSuperKeyPlusK);
    return () => window.removeEventListener("keydown", focusOnSuperKeyPlusK);
  }, [onSearchChange]);

  return (
    <div className="flex flex-col gap-5 mb-8">
      <div className="flex flex-row items-start justify-between">
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            {Icon && <Icon className="h-6 w-6 text-white" />}
            <h1 className="text-2xl text-primary">{title}</h1>
            {count !== undefined && <span className="text-2xl text-tertiary">({count})</span>}
          </div>
          <p className="text-sm text-tertiary">{subtitle}</p>
        </div>
        <div className="flex flex-row items-center gap-3">
          {actions}
          {onSearchChange && (
            <Input
              icon={SearchMd}
              className="w-80"
              placeholder="Search"
              value={search}
              onChange={onSearchChange}
              groupRef={searchGroupRef}
              shortcut="⌘K"
            />
          )}
        </div>
      </div>
    </div>
  );
};
